/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_ResetInputs */

const en_camera_reset = /** @type {(inputs: Camera_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset camera to default view`)
};

const fr_camera_reset = /** @type {(inputs: Camera_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser la caméra à la vue par défaut`)
};

const ms_sg2_camera_reset = /** @type {(inputs: Camera_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapkan semula kamera ke paparan lalai`)
};

/**
* | output |
* | --- |
* | "Reset camera to default view" |
*
* @param {Camera_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_reset = /** @type {((inputs?: Camera_ResetInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_ResetInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_reset(inputs)
	if (locale === "fr") return fr_camera_reset(inputs)
	return ms_sg2_camera_reset(inputs)
});